// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__2vDWa","container":"Footer_container__Vll7-","copyright":"Footer_copyright__3acfS","socials":"Footer_socials__2QCsx"};